module.exports = __webpack_public_path__ + "img/loan_check_list.9ce5a47a.png";